import React from "react";
import Store from "@/assets/img/liff/home/store.png";
import Consultant from "@/assets/img/liff/home/consultant.png";
import StoreLogo from "@/assets/img/liff/home/store_logo.jpg";

const StoreConsultant = ({ memberConsultant }) => {
	const storeName = memberConsultant?.storeName || "未綁定";
	const staffDisplayName = memberConsultant?.staffDisplayName || "未綁定";

	const getTitleStyle = (name) => {
		if (name.length > 8) {
			return {
				marginBottom: "0.5em",
			};
		}
	};

	const getTextStyle = (name) => {
		if (name.length > 6) {
			return {
				fontSize: "3em",
				lineHeight: "1.3",
			};
		}
	};

	return (
		<div className="store-consultant">
			<div className="top-bar">
				<label>專屬門市顧問</label>
			</div>
			<div className="consultant-list">
				{/* 綁定門市 */}
				<div className="consultant">
					<img
						className="consultant-img"
						src={memberConsultant?.storeName ? StoreLogo : Store}
						alt=""
					/>
					<div className="consultant-info">
						<label className="title" style={getTitleStyle(storeName)}>
							綁定門市：
						</label>
						<label className="name" style={getTextStyle(storeName)}>
							{storeName}
						</label>
					</div>
				</div>
				{/* 門市顧問 */}
				<div className="consultant">
					<img
						className="consultant-img"
						src={memberConsultant?.staffAvatar || Consultant}
						alt=""
					/>
					<div className="consultant-info">
						<label className="title" style={getTitleStyle(staffDisplayName)}>
							門市顧問：
						</label>
						<label className="name" style={getTextStyle(staffDisplayName)}>
							{staffDisplayName}
						</label>
					</div>
				</div>
			</div>
		</div>
	);
};

export { StoreConsultant };
